import React, { useState } from 'react';
import RangeSlider from 'react-bootstrap-range-slider';
import { Form } from "react-bootstrap";
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../grid-container/GridContainer"

export default function UiLineRangeSlider(props) {
    const [value, setValue] = useState(0);

    return (
        <>
            <UiSingleRow>
                <UiCol lg="8">
                    <div className='sb-range-slider-wr'>
                        <div className='sb-min-value '>{props.min}</div>
                        <RangeSlider
                            value={value}
                            min={props.min}
                            max={props.max}
                            tooltipPlacement='bottom'
                            tooltip='on'
                            className='line-slider slider-progress'
                            onChange={changeEvent => setValue(changeEvent.target.value)}
                        />
                        <div className='sb-max-value '>{props.max}</div>
                    </div>
                </UiCol>
            </UiSingleRow>


        </>
    )
}
